import styled from '@emotion/styled';
import { colorToAlpha } from 'helpers/insight';
import ShareIcon from 'assets/svg/share.svg';
import { typographyFontSizeCfg, typographyLineHeightCfg } from 'ds/components/typography/types';
import { H1 } from 'ds/components/typography';

export const EnhancedShareButton = styled(ShareIcon)`
  height: 32px;
  width: 32px;
  padding: 4px;
  ${({ theme }) => `background: ${colorToAlpha(theme.colors.neutrals.black, 0.4)}`};
  border-radius: ${({ theme }) => theme.borderRadius.round};
`;

export const ItemWrapper = styled.div<{ negativeMargin?: boolean }>`
  ${({ theme, negativeMargin }) => `
    ${negativeMargin && `margin: -8px`};
    display: flex;
    flex: 1;
    svg {
      width: 16px;
      height: 16px;
      path {
        fill: ${theme.colors.neutrals.grey1};
      }
    }
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    svg {
      margin: ${theme.spacing(0.5)} 0;
    }
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    svg {
      margin-top: ${theme.spacing(0.25)};
    }
  `}
`;

export const IconWrapper = styled.div<{ isWhite?: boolean }>`
  ${({ theme, isWhite }) => `
    svg {
      vertical-align: middle;
      path {
        fill: ${isWhite ? theme.colors.neutrals.white : theme.colors.neutrals.grey1};
      }
    }
  `}
`;

export const ShareModalHeader = styled(H1)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
  textAlign: 'center',
  fontSize: `${typographyFontSizeCfg.h1.mobile}px !important`,
  lineHeight: `${typographyLineHeightCfg.h1.mobile}px !important`,
  marginBottom: theme.spacing(6),
  marginTop: theme.spacing(4),
}));

export const ShareModalContent = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '290px',
  margin: '0 auto',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const ShareModalItem = styled.div(({ theme }) => ({
  display: 'flex',
  color: theme.colors.neutrals.grey1,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(1),
  position: 'relative',
}));

export const CopyTooltip = styled.div`
  position: absolute;
  z-index: 2;
  left: 50%;
  bottom: calc(100% + 14px);
  transform: translateX(-50%);
  background: #074351;
  ${({ theme }) => `
    border-radius: ${theme.borderRadius.tiny};
    padding: ${theme.spacing(1)};
    color: ${theme.colors.neutrals.white};
  `}
  white-space: nowrap;
  :before {
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    content: '';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #074351;
  }
`;
